import { WEBFLOW_SCRIPT_ENV } from '../src/webflow-script-env';

export const getOnlyElementByAttribute = (
  attribute: string
): Element | null => {
  try {
    const divArray = document.querySelectorAll(`${attribute}`);

    let element;

    if (divArray.length > 1) {
      if (WEBFLOW_SCRIPT_ENV !== 'production') {
        console.log(`Multiple ${attribute} found`);
      }
      element = null;
    } else {
      element = divArray[0];
    }

    return element;
  } catch (error) {
    throw error;
  }
};
